var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard1Front(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.94 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:.01em;}.cls-2{fill:#e53338;}.cls-3{letter-spacing:0em;}.cls-4{letter-spacing:-.05em;}.cls-5{letter-spacing:0em;}.cls-6{font-family:CFArmadilloStd-Medium, 'CF Armadillo Std';font-size:11px;font-weight:500;}.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-7{font-family:Helvetica-Bold, Helvetica;font-weight:700;}.cls-7,.cls-8{font-size:9px;}.cls-9{clip-path:url(#clippath-2);}.cls-10{fill:#f4d198;}.cls-11{fill:#f9a133;}.cls-12{stroke:#42b654;}.cls-12,.cls-13,.cls-14,.cls-15{stroke-miterlimit:10;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17{fill:none;}.cls-13{stroke:#a9987d;stroke-width:.37px;}.cls-18{clip-path:url(#clippath-1);}.cls-14,.cls-16{stroke:#fff;stroke-width:2px;}.cls-19{letter-spacing:0em;}.cls-8{font-family:CFArmadilloStd-Light, 'CF Armadillo Std';font-weight:300;}.cls-20{letter-spacing:0em;}.cls-21{fill:#90d0b9;}.cls-15{stroke:#90d0b9;}.cls-22{fill:#73c16e;}.cls-16{stroke-linecap:round;stroke-linejoin:round;}.cls-23{letter-spacing:-.02em;}.cls-24{clip-path:url(#clippath);}.cls-25{fill:#f26c36;}.cls-26{clip-path:url(#clippath-3);}.cls-27{letter-spacing:-.05em;}.cls-28{letter-spacing:-.06em;}.cls-29{letter-spacing:0em;}.cls-30{letter-spacing:0em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 240.94,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 240.95,
    height: 155.91
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m224.44,155.91H16.5C7.39,155.91,0,148.52,0,139.41V16.5C0,7.39,7.39,0,16.5,0h207.95c9.11,0,16.5,7.39,16.5,16.5v122.91c0,9.11-7.39,16.5-16.5,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m203.8,135.16c-2.43,1.96-5.53,3.13-8.91,3.13-7.85,0-14.22-6.36-14.22-14.22s6.37-14.22,14.22-14.22c3.38,0,6.48,1.17,8.91,3.14-3.25,2.6-5.33,6.6-5.33,11.08s2.08,8.49,5.33,11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m209.12,124.07c0,4.48-2.07,8.48-5.32,11.09-3.25-2.6-5.33-6.6-5.33-11.09s2.08-8.48,5.33-11.08c3.25,2.6,5.32,6.6,5.32,11.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m226.92,124.07c0,7.86-6.37,14.22-14.23,14.22-3.36,0-6.46-1.17-8.89-3.13,3.25-2.61,5.32-6.61,5.32-11.09s-2.07-8.48-5.32-11.08c2.43-1.97,5.53-3.14,8.89-3.14,7.86,0,14.23,6.37,14.23,14.22"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(179.53 147.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "mastercard")), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m35.34,76.66v12.29c0,2.4-1.72,4.4-3.99,4.84-.3.06-.62.09-.94.09H14.08c-.32,0-.63-.03-.94-.09-2.27-.44-3.99-2.44-3.99-4.84v-12.29c0-.42.05-.84.16-1.23h0c.55-2.13,2.48-3.7,4.77-3.7h16.34c2.28,0,4.19,1.54,4.76,3.64.11.41.17.84.17,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m35.34,76.66v12.29c0,2.4-1.72,4.4-3.99,4.84-.3.06-.62.09-.94.09H14.08c-.32,0-.63-.03-.94-.09-2.27-.44-3.99-2.44-3.99-4.84v-12.29c0-.42.05-.84.16-1.23h0c.55-2.13,2.48-3.7,4.77-3.7h16.34c2.28,0,4.19,1.54,4.76,3.64.11.41.17.84.17,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.36,75.36c1.43,0,2.59,1.16,2.59,2.59,0,.71-.29,1.36-.76,1.83-.47.47-1.11.76-1.83.76h-7.45c-.25,0-.51,0-.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m27.4,75.36c-.72,0-1.36.29-1.83.76-.47.47-.76,1.11-.76,1.83,0,1.43,1.16,2.59,2.59,2.59,2.65,0,5.3.01,7.95.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m9.15,86.23c.41-.2.88-.31,1.37-.31h6.25c1.76,0,3.19,1.43,3.19,3.19v1.49c0,1.76-1.43,3.19-3.19,3.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m35.34,86.12c-.34-.12-.71-.19-1.1-.19h-6.25c-1.76,0-3.19,1.43-3.19,3.19v1.49c0,1.76,1.43,3.19,3.19,3.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 28.59,
    y1: 80.56,
    x2: 28.59,
    y2: 85.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 15.97,
    y1: 80.56,
    x2: 15.97,
    y2: 85.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m206.43,35.41c-2.12,0-3.84-1.72-3.84-3.84s1.72-3.84,3.84-3.84,3.84,1.72,3.84,3.84-1.72,3.84-3.84,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m214.17,40.08c4.7-4.59,4.69-12.2,0-17.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m219.89,46.04c7.98-7.79,7.98-20.74-.03-28.94"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(45.05 130.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "85"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 13.38,
    y: 0
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 19.73,
    y: 0
  }, "9 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 29.5,
    y: 0
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 35.6,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 42.12,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 48.1,
    y: 0
  }, "4 4488 9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 94.78,
    y: 0
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 101.09,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 107.17,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(45.05 145.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 0,
    y: 0
  }, "AN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 11.43,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 16.11,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 22.05,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 27.98,
    y: 0
  }, "IOS K. ALEXA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 81.35,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 87.28,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 93.22,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 99.06,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 105,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m76.89,23.93c0-.81.25-1.5.74-2.08.65-.77,1.64-1.17,2.65-1.17h19.58c.89,0,1.65.31,2.29.94.64.62.96,1.39.96,2.31v15.31c0,.92-.32,1.69-.96,2.31-.64.62-1.4.93-2.29.93h-19.59c-1.01,0-1.99-.4-2.65-1.17-.49-.58-.74-1.27-.74-2.08v-15.31Zm23.1,15.59v-15.86s-.04-.08-.08-.08h-19.12c-.43,0-.78.35-.78.78v14.46c0,.43.35.78.78.78h19.12s.08-.04.08-.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m23.33,42.49h-9.88c-.89,0-1.65-.31-2.3-.94-.64-.62-.96-1.4-.96-2.32v-15.34c0-.92.32-1.69.96-2.32.64-.62,1.4-.94,2.3-.94h9.88v2.9h-10.01v16.05h10.01v2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m39.44,21.58c-.64-.62-1.41-.94-2.3-.94h-9.88v2.9h10.01v5.57h-14.54c-.89,0-1.65.31-2.3.94-.64.62-.96,1.4-.96,2.32v6.87c0,.92.32,1.69.96,2.32.64.62,1.4.94,2.3.94h14.4c.89,0,1.66-.31,2.3-.94.64-.62.96-1.4.96-2.32v-15.34c0-.92-.32-1.7-.96-2.32m-2.16,18.01h-14.67v-7.58h14.67v7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m74.49,42h-2.97v-13.72c-1.71,0-3.41,0-5.12-.01v-4.72h-20.46v8.47h20.47v-.99h3.12c.03.62-.02,1.09-.07,1.32-.06.31-.17.57-.17.57-.05.12-.25.59-.7,1.04-.07.07-.14.13-.21.19-.59.52-1.29.77-2.11.77h-20.33v7.58h-3.12v-18.59c0-.92.32-1.69.96-2.32.64-.62,1.41-.94,2.3-.94h20.19c.89,0,1.66.31,2.3.94.64.62.96,1.4.96,2.32v1.26h4.93c.01,5.62.02,11.23.03,16.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m72.89,20.64h0c.86,0,1.56.7,1.56,1.56v.49c0,.86-.7,1.56-1.56,1.56s-1.56-.7-1.56-1.56v-.49c0-.86.7-1.56,1.56-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m39.1,71.16c0-1.14.35-2.13,1.05-2.95.92-1.09,2.32-1.66,3.75-1.66h27.76c1.26,0,2.34.44,3.25,1.32.9.88,1.36,1.98,1.36,3.28v21.71c0,1.31-.45,2.4-1.36,3.28-.91.88-1.99,1.33-3.25,1.33h-27.76c-1.43,0-2.83-.57-3.75-1.66-.7-.82-1.04-1.8-1.04-2.95v-21.71Zm32.75,22.09v-22.48c0-.06-.05-.12-.12-.12h-27.11c-.61,0-1.11.5-1.11,1.11v20.5c0,.61.5,1.11,1.11,1.11h27.11c.06,0,.12-.05.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m62.38,78.67c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 51.52,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m113.91,92.87c0,1.15-.35,2.13-1.04,2.95-.92,1.09-2.32,1.66-3.75,1.66h-27.76c-1.26,0-2.35-.44-3.25-1.32-.9-.88-1.36-1.98-1.36-3.28v-21.71c0-1.3.45-2.4,1.36-3.28.9-.88,1.99-1.32,3.25-1.32h27.76c1.43,0,2.83.57,3.75,1.66.7.82,1.04,1.8,1.04,2.95v21.71Zm-32.63.5h27.11c.61,0,1.11-.5,1.11-1.11v-20.5c0-.61-.5-1.11-1.11-1.11h-27.11c-.06,0-.12.05-.12.12v22.48c0,.06.05.12.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m90.63,85.36c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 101.49,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m114.39,71.16c0-1.14.35-2.13,1.04-2.95.92-1.09,2.32-1.66,3.75-1.66h27.76c1.26,0,2.34.44,3.25,1.32.9.88,1.36,1.98,1.36,3.28v21.71c0,1.31-.45,2.4-1.36,3.28-.91.88-1.99,1.33-3.25,1.33h-27.76c-1.43,0-2.83-.57-3.75-1.66-.7-.82-1.04-1.8-1.04-2.95v-21.71Zm32.75,22.09v-22.48c0-.06-.05-.12-.12-.12h-27.11c-.61,0-1.11.5-1.11,1.11v20.5c0,.61.5,1.11,1.11,1.11h27.11c.06,0,.12-.05.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m137.67,78.67c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 126.81,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m189.21,92.87c0,1.15-.35,2.13-1.04,2.95-.92,1.09-2.32,1.66-3.75,1.66h-27.76c-1.26,0-2.35-.44-3.25-1.32-.9-.88-1.36-1.98-1.36-3.28v-21.71c0-1.3.45-2.4,1.36-3.28.9-.88,1.99-1.32,3.25-1.32h27.76c1.43,0,2.83.57,3.75,1.66.7.82,1.04,1.8,1.04,2.95v21.71Zm-32.63.5h27.11c.61,0,1.11-.5,1.11-1.11v-20.5c0-.61-.5-1.11-1.11-1.11h-27.11c-.06,0-.12.05-.12.12v22.48c0,.06.05.12.12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m165.93,85.36c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 176.79,
    cy: 82.02,
    r: 5.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m189.69,71.16c0-1.14.35-2.13,1.04-2.95.92-1.09,2.32-1.66,3.75-1.66h27.76c1.26,0,2.34.44,3.25,1.32.9.88,1.36,1.98,1.36,3.28v21.71c0,1.31-.45,2.4-1.36,3.28-.91.88-1.99,1.33-3.25,1.33h-27.76c-1.43,0-2.83-.57-3.75-1.66-.7-.82-1.04-1.8-1.04-2.95v-21.71Zm32.75,22.09v-22.48c0-.06-.05-.12-.12-.12h-27.11c-.61,0-1.11.5-1.11,1.11v20.5c0,.61.5,1.11,1.11,1.11h27.11c.06,0,.12-.05.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m212.97,78.67c0-.4.14-.74.42-1.01.28-.27.61-.41,1-.41h8.62c.39,0,.72.14,1,.41.28.27.42.61.42,1.01v6.69c0,.4-.14.74-.42,1.01-.28.27-.61.41-1,.41h-8.62c-.39,0-.72-.14-1-.41-.28-.27-.42-.61-.42-1.01v-6.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 202.11,
    cy: 82.02,
    r: 5.43
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard1Front);
export default __webpack_public_path__ + "static/media/bank-card-1-front.905d78f0be2f650f313e8392a94217e0.svg";
export { ForwardRef as ReactComponent };